import { FunctionComponent, HTMLAttributes } from 'react';

const IconCarEngine: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = ({
  title,
  ...props
}) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 10.1875V8.34638H1V7.02086C1 6.73831 0.782593 6.50003 0.500041 6.50003C0.217488 6.50003 0 6.73831 0 7.02086V11.513C0 11.7956 0.217488 12.0274 0.500041 12.0274C0.782593 12.0274 1 11.7956 1 11.513V10.1875H2Z"
      fill="#359AD2"
    />
    <path
      d="M15 8.34651H14V10.1877H15V11.5132C15 11.7957 15.2175 12.021 15.5001 12.021C15.7826 12.021 16 11.7957 16 11.5132V7.02099C16 6.73844 15.7683 6.49364 15.5 6.50015C15.2317 6.50666 15 6.73844 15 7.02099V8.34651Z"
      fill="#359AD2"
    />
    <path
      d="M11.2465 2.00003H6.75431C6.47176 2.00003 6.23999 2.2318 6.23999 2.51435V2.9857C6.23999 3.26826 6.47176 3.50003 6.75431 3.50003H8.07984V4.00003H9.92098V3.50003H11.2465C11.5291 3.50003 11.7608 3.26826 11.7608 2.9857V2.51435C11.7608 2.2318 11.5291 2.00003 11.2465 2.00003Z"
      fill="#359AD2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.23309 13.6888L3.71225 12.1693H2.66538C2.29949 12.1693 2.00001 11.8698 2.00001 11.5039V7.04058C2.00001 6.6747 2.29949 6.37522 2.66538 6.37522H3.77736L5.34897 4.70465C5.53126 4.5458 5.77345 4.48981 6.056 4.50153H13.4141C13.638 4.52627 13.8086 4.6122 13.9128 4.77366C14.0035 4.912 14.0024 4.99801 14.0005 5.13574C14.0003 5.15616 14 5.17771 14 5.20074V10.4909C14 10.5061 14 10.5211 14 10.5358C14.0005 10.8649 14.0007 11.0738 13.7839 11.3555C13.7409 11.4115 13.6927 11.4649 13.6393 11.5143L11.3177 13.7878C11.2018 13.9167 11.026 13.987 10.7943 14H5.95314C5.65757 13.987 5.41668 13.8854 5.23309 13.6888ZM8.29561 9.54445L6.64978 9.3895L8.01436 6.39992H9.88025L8.82166 8.11476L10.7253 8.3257L7.23051 12.521L8.29561 9.54445Z"
      fill="#359AD2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00001 7.04058C2.00001 6.6747 2.29949 6.37522 2.66538 6.37522H3.77736L5.34897 4.70465C5.53126 4.5458 5.77345 4.48981 6.056 4.50153H13.4141C13.638 4.52627 13.8086 4.6122 13.9128 4.77366C14.0035 4.912 14.0024 4.99801 14.0005 5.13574C14.0003 5.15616 14 5.17771 14 5.20074L14 10.5358C14.0005 10.8649 14.0007 11.0738 13.7839 11.3555C13.7409 11.4115 13.6927 11.4649 13.6393 11.5143L11.3177 13.7878C11.2018 13.9167 11.026 13.987 10.7943 14H5.95314C5.65757 13.987 5.41668 13.8854 5.23309 13.6888L3.71225 12.1693H2.66538C2.29949 12.1693 2.00001 11.8698 2.00001 11.5039V7.04058ZM8.82166 8.11476L9.88025 6.39992H8.01436L6.64978 9.3895L8.29561 9.54445L7.23051 12.521L10.7253 8.3257L8.82166 8.11476Z"
      fill="#359AD2"
    />
  </svg>
);

export default IconCarEngine;
